import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import { Typography } from '@mui/material';
import { DataType } from './type';

type Props = {
    data: DataType[];
    count: number;
    page: number;
    onSetPage: (page: string) => void;
};

export default function RegisteredContentAssesorsTable({ data, count, page, onSetPage }: Props) {
    const rowsPerPage = 10;

    const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
        onSetPage(String(value));
    };

    return (
        <>
            <TableContainer component={Paper} sx={{ marginTop: '24px', marginBottom: '48px' }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{ background: '#EDF4F7' }}>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Language Proficiency</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <Typography variant="body1" sx={{ textAlign: 'center', py: 4 }}>
                                        No results found
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {data.map((row, index) => (
                            <TableRow key={`${row.name}-${index}`}>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.email}</TableCell>
                                <TableCell>{row.language_proficiency}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Stack justifyContent="center" sx={{ my: 1 }}>
                <Pagination
                    count={Math.ceil(count / rowsPerPage)}
                    page={page}
                    hideNextButton={Math.round(count / rowsPerPage) <= 6}
                    hidePrevButton={Math.round(count / rowsPerPage) <= 6}
                    siblingCount={2}
                    color="primary"
                    variant="text"
                    onChange={handleChange}
                    shape="rounded"
                    sx={{
                        '& ul': {
                            justifyContent: 'center'
                        },
                        '& ul li button': {
                            border: '1px solid #EDEDED'
                        },
                        '& ul li .MuiPaginationItem-previousNext': {
                            border: 'none'
                        }
                    }}
                />
            </Stack>
        </>
    );
}
